// extracted by mini-css-extract-plugin
module.exports = {"inspirationTileWrapper":"InspirationTile_inspirationTileWrapper__0aeUd"};